import type { TaxIdType } from "../TaxIdType";
import { getAmericas } from "./americas";
import { getEurope } from "./europe";
import { getOthers } from "./others";

// Built from https://stripe.com/docs/billing/customer/tax-ids#supported-tax-id
// TODO: fetch this from Stripe API once they support it.
let _cached: TaxIdType[] | null = null;

export const getTaxIdTypes = (): TaxIdType[] => {
  _cached ??= [...getAmericas(), ...getEurope(), ...getOthers()].sort((a, b) =>
    a.label.localeCompare(b.label, "en", { sensitivity: "base" }),
  );
  return _cached;
};
